import { Theme } from '@mui/material/styles';

export const main = (theme: Theme) => ({
    paddingTop: theme.spacing(10.625),
    marginTop: theme.spacing(7.5),
    minHeight: `calc(100vh - ${theme.footerHeight} - ${theme.headerHeight} - 70px)`,
}) as const;

export const box = (theme: Theme) => ({
    marginBottom: theme.spacing(5),
}) as const;

export const title = {
    fontSize: 24,
    fontWeight: 700,
} as const;

export const italic = {
    fontStyle: 'italic',
} as const;
